import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalProgressSpinnerService {
  public readonly loading$: Observable<boolean>;
  private readonly _loading$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  constructor() {
    this.loading$ = this._loading$.asObservable();
  }

  public showLoader(): void {
    this._loading$.next(true);
  }

  public hideLoader(): void {
    this._loading$.next(false);
  }

  public setLoader(isLoading: boolean): void {
    this._loading$.next(isLoading);
  }
}
